import React from 'react';
import {Link, Outlet} from "react-router-dom";


const Layout = (props) => {

    return (
        <div>
            <div className={'row header align-center justify-space-between'}>
                <a href={'http://alsu.tatar'} className={'row align-center'}><img src={require('../assets/nLogo.png')} style={{width: 200, height: 75, objectFit: 'contain'}}></img>
                   </a>
                <div className={'row justify-end mr-0 ml-auto menu-text text__white'} style={{width: '50%'}}>
                    <Link to={'/'} className={'mr-1 ml-9  text__white'}>КАТАЛОГ</Link>
                    {/* <Link to={'/'} className={'mr-9 text__white'}>ПРОЕКТ ТУРЫНДА</Link>
                    <Link to={'/'} className={'text__white'}>КОНТАКТЛАР</Link> */}
                </div>

            </div>
            <div style={{width: '100%', height: 3, background: '#FFFFFF'}}></div>
            <Outlet />
        </div>
    );
};

export default Layout;
